import { Pipe, PipeTransform } from "@angular/core";
import { LocaleService } from "../services/locale.service";
import moment, { Moment } from "moment";

@Pipe({ name: "stringToMoment", standalone: true })
export class StringToMomentPipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}
  transform(value: string): Moment {
   let myMoment : Moment = moment(value).utc(true);
   return myMoment
  }
}
